//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import { date } from "quasar";
import { APP_DATE_SLASH } from "@/assets/js/appConfig";
import { mapActions } from "vuex";
import HistoryItem from "./HistoryItem.vue";

export default {
    name: "HistoryModal",
    components: {
        AQModal,
        AQButton,
        AQInput,
        HistoryItem,
        AQDropdown
    },
    props: {},
    data() {
        return {
            changeHistoryModal: true,
            historyItems: [],
            loading: false,
            filterInput: "",
            showFilters: false,
            resultsFound: false,
            dateFormat: "DD.MM.YYYY",
            eventTypeOptions: [
                {
                    value: "CREATE",
                    label: "Create"
                },
                {
                    value: "DELETE",
                    label: "Delete"
                },
                {
                    value: "DELETE_ALL",
                    label: "Delete all data"
                },
                {
                    value: "IMPORT",
                    label: "Import"
                },
                {
                    value: "RENAME",
                    label: "Rename"
                }
            ],
            resetDefaultVal: false,
            eventType: [],
            userEmail: null,
            from: null,
            to: null,
            myLocaleRo: {
                days: "Du_Lu_Ma_Mi_Joi_Vi_Sâ".split("_"),
                daysShort: "Du_Lu_Ma_Mi_Joi_Vi_Sâ".split("_"),
                months: "Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec".split("_"),
                monthsShort: "Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec".split("_"),
                firstDayOfWeek: 1
            },
            activeFilters: {
                eventType: [],
                userEmail: null,
                from: null,
                to: null
            }

        };
    },
    computed: {
        filters() {
            const [{ value: eventType = null } = {}] = this.eventType || [];
            return {
                eventType,
                userEmail: this.userEmail,
                from: this.from ? date.formatDate(new Date(this.from), "YYYY-MM-DDTHH:mm:ssZ") : null,
                to: this.to ? date.formatDate(new Date(this.to), "YYYY-MM-DDTHH:mm:ssZ") : null
            };
        },
        myLocale() {
            let localeToReturn = null;
            if (this.userDataDetails && this.userDataDetails.language === "ro") {
                localeToReturn = this.myLocaleRo;
            }
            return localeToReturn;
        },
        setFromDateProps() {
            return {
                options: this.optionsFromDate,
                noTimeOptions: true,
                locale: this.myLocale
            };
        },
        setToDateProps() {
            return {
                options: this.optionsToDate,
                noTimeOptions: true,
                locale: this.myLocale
            };
        },
        hasActiveFilters() {
            const value = !!this.activeFilters.to || !!this.activeFilters.from || !!this.activeFilters.userEmail || !!this.activeFilters.eventType?.[0]?.value;
            return value ? "" : "outline";
        }
    },
    created() {
        this.getChangeHistory();
    },
    methods: {
        ...mapActions("dataStore", [
            "getStructureAudit"
        ]),
        getChangeHistory() {
            this.loading = true;
            this.historyItems = [];
            this.activeFilters = {
                eventType: this.eventType,
                userEmail: this.userEmail,
                from: this.from,
                to: this.to
            };
            this.getStructureAudit({ ...this.filters }).then(data => {
                this.historyItems = data;
                this.loading = false;
            });
        },
        filterBySearchInput({ entityName = "", entityCode = "" }) {
            const name = (entityName || "").toLowerCase();
            const code = (entityCode || "").toLowerCase();
            const term = this.filterInput.toLowerCase();
            const result = name.includes(term) || code.includes(term);
            if (result) {
                this.resultsFound = true;
            }
            return result;
        },
        clearFilters() {
            this.resetDefaultVal = true;
            setTimeout(() => {
                this.resetDefaultVal = false;
                this.getChangeHistory();
            }, 0);
            this.userEmail = null;
            this.from = null;
            this.to = null;
            this.activeFilters = {
                eventType: [],
                userEmail: null,
                from: null,
                to: null
            };
        },
        cancelFilters() {
            this.showFilters = false;
            this.eventType = this.activeFilters.eventType;
            this.userEmail = this.activeFilters.userEmail;
            this.from = this.activeFilters.from;
            this.to = this.activeFilters.to;
        },
        optionsToDate(data) {
            let valid = true;
            if (this.from) {
                const fromDate = date.formatDate(this.from, APP_DATE_SLASH);
                valid = data > fromDate;
            }
            return valid;
        },
        optionsFromDate(data) {
            let valid = true;
            if (this.to) {
                const toDate = date.formatDate(this.to, APP_DATE_SLASH);
                valid = data < toDate;
            }
            return valid;
        }
    }
};
